import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

function Article() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueVal, setIsTrueVal] = React.useState(false);
  const [isTrueValPub, setIsTrueValPub] = React.useState(false);
  const [isTrueValAuth, setIsTrueValAuthor] = React.useState(false);
  const [isTrueValImag, setIsTrueValIMg] = React.useState([0,false]);
   
  const [inputFieldsJp1, setInputFieldsJp1] = useState({
      type_name: '',
      url:'',
      headline:'',
      description:'',
      auth_type:'',
      auther_name:'',
      auther_url:'',
      pub_name:'',
      pub_url:'',
      datePublished:'',
      dateModified:'',
  }) 
  const [inputFieldsJp, setInputFieldsJp] = useState(['']) 
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange4 = (index, evnt) => {
    const { value } = evnt.target; 
      let retunrimgurlvalidation = !value || urlPatternValidation(value);
      if(retunrimgurlvalidation === false)
      {
        setIsTrueValIMg([index, true]);
      }
      else{
        setIsTrueValIMg([index, false]);
        const list = [...inputFieldsJp];
        list[index] = value; 
        setInputFieldsJp(list);
      } 
   
  } 
  const handleChange5 = (evnt) => {
    const { name, value } = evnt.target;
    if(name === 'url'){
      let isTrueValss = !value || urlPatternValidation(value);
      if(isTrueValss === false)
      {
        setIsTrueVal(true);
      }
      else{
        setIsTrueVal(false);
      }
    }
    if(name === 'auther_url'){
      let isvalid = !value || urlPatternValidation(value);
      if(isvalid === false)
      {
        setIsTrueValAuthor(true);
      }
      else{
        setIsTrueValAuthor(false);
      }
    }
    if(name === 'pub_url'){
      let isvalidPub = !value || urlPatternValidation(value);
      if(isvalidPub === false)
      {
        setIsTrueValPub(true);
      }
      else{
        setIsTrueValPub(false);
      }
    }
    if(name==='headline' && value.length > 110){
        
    }else{
      setInputFieldsJp1((prevalue) => {
        return {
          ...prevalue,   // Spread Operator              
          [name]: value
        }
      })
    } 
  }
  function MyButton(props) {
    return <button {...props} />
  }
  const addInputFieldJp = () => {
    setInputFieldsJp([...inputFieldsJp, ''])
  }
  const removeInputFieldsJp = (index) => {
    const rows = [...inputFieldsJp];
    rows.splice(index, 1);
    setInputFieldsJp(rows);
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  
  const jpj = Object.values(inputFieldsJp);  
  const JpIsMyCopy = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/", 
      "@type": "`+inputFieldsJp1.type_name+`",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "`+inputFieldsJp1.url+`"
      }, 
      "headline": "`+inputFieldsJp1.headline+`",
      "description": "`+inputFieldsJp1.description+`",
      "image":[`+
      jpj.map((items) =>
        JSON.stringify(items)
      )
      + `],
      "author": {
        "@type": "`+inputFieldsJp1.auth_type+`",
        "name": "`+inputFieldsJp1.auther_name+`",
        "url": "`+inputFieldsJp1.auther_url+`"
      },  
      "publisher": {
        "@type": "Organization",
        "name": "`+inputFieldsJp1.pub_name+`",
        "logo": {
          "@type": "ImageObject",
          "url": "`+inputFieldsJp1.pub_url+`"
        }
      },
      "datePublished": "`+inputFieldsJp1.datePublished+`",
      "dateModified": "`+inputFieldsJp1.dateModified+`"
    }
    </script><!--ArticleList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;
    const resetFun = () =>{
      const sws_rows = {
        type_name: '',
        url:'',
        headline:'',
        description:'',
        auth_type:'',
        auther_name:'',
        auther_url:'',
        pub_name:'',
        pub_url:'',
        datePublished:'',
        dateModified:'',
      }; 
      setInputFieldsJp1(sws_rows);
      setInputFieldsJp([]);
    }
    return (
        <div className='row mt-5 article_row'>
          <div className='col-md-8 mb-5 border ps-0'>
           <div className='mt-2 mb-3 article_title'> <i className="fa-solid fa-newspaper"></i>  <b>Article</b> </div>
           <div className="row input_fields d-flex">
              <div className="col-6 mb-2 pe-0">
                <div className="form-group me-2 mb-2">
                <label>Article Type</label>
                  <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.type_name} name="type_name" className="form-control">
                    {/* <option>Please Select Type</option> */}
                    <option value="Article">Article</option>
                    <option value="NewsArticle">NewsArticle</option>
                    <option value="BlogPosting">BlogPosting</option>
                  </select>
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
              </div>
              <div className="col-6 mb-2 ps-0">
                <div className="form-group me-2 mb-2">
                <label>URL</label>
                  <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.url} name="url" className="form-control" />
                </div>
                  {isTrueVal && (
                    <div style={{ color: "#F61C04" }}>Invalid URL</div>
                  )}
              </div>
              <div className="col-12 mb-2">
                <div className="form-group me-2 mb-2">
                <label>HeadLine</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.headline} name="headline" className="form-control" />
                  <span className=""> {inputFieldsJp1.headline && ((inputFieldsJp1.headline).length > 0)?(inputFieldsJp1.headline).length: 0} / 110</span>
                </div>
              </div>
            </div>
            
           {inputFieldsJp &&
             inputFieldsJp.map((data, index) => { 
               return (
                 <div className=" row input_fields d-flex" key={index}>
                   <div className="col-10">
                     <div className="form-group me-2 mb-2">
                     <label>Image URL</label>
                       <input type="text" onChange={(evnt) => handleChange4(index, evnt)} value={data} name="image" className="form-control"/>
                       {(isTrueValImag[1] && isTrueValImag[0] === index) && (
                        <div style={{ color: "#F61C04" }}>Image Invalid URL</div>
                      )}
                     </div>
                   </div>
                   <div className="mb-2 d-flex col-2 text-center justify-content-center align-items-end">
                     {(inputFieldsJp.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsJp(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                   </div>
                 </div>
               )
             })
           }  
           <div className="col mt-3 mb-3">
             <button className="btn btn-outline-success addbtn" onClick={addInputFieldJp}><i className="fa-solid fa-plus"></i></button>
           </div>
           <div className="row input_fields d-flex">
              <div className="col-12">
                <div className="form-group me-2 mb-2">
                <label>Short Description of Article</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.description} name="description" className="form-control" />
                </div>
              </div>
              <div className="col-6 pe-0">
                <div className="form-group me-2 mb-2">
                <label>Author @type</label>
                  <select className="form-control" name="auth_type" value={inputFieldsJp1.auth_type} onChange={(evnt) => handleChange5(evnt)}>
                    {/* <option>Select Auther Type</option> */}
                    <option value="person">Person</option>
                    <option value="organization">Organization</option>
                  </select>
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
              </div>
              <div className="col-6 ps-0">
                <div className="form-group me-2 mb-2">
                <label>Author</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.auther_name} name="auther_name" className="form-control" />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group me-2 mb-2">
                <label>Author URL</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.auther_url} name="auther_url" className="form-control" />
                  {isTrueValAuth && (
                    <div style={{ color: "#F61C04" }}>Invalid URL</div>
                  )}
                </div>
              </div>
              <div className="col-6 pe-0">
                <div className="form-group me-2 mb-2">
                <label>Publisher</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.pub_name} name="pub_name" className="form-control"  />
                </div>
              </div>
              <div className="col-6 ps-0">
                <div className="form-group me-2 mb-2">
                <label>Publisher Logo URL</label>
                  <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.pub_url} name="pub_url" className="form-control" />
                  {isTrueValPub && (
                    <div style={{ color: "#F61C04" }}>Invalid URL</div>
                  )}
                </div>
              </div>
              <div className="col-6 pe-0">
                <label>Publish Date </label>
                <div className="form-group me-2 mb-2">
                  <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.datePublished} name="datePublished" className="form-control" placeholder="datePublished" />
                </div>
              </div>
              <div className="col-6 ps-0">
                <label>Modified Date</label>
                <div className="form-group me-2 mb-2">
                  <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.dateModified} name="dateModified" className="form-control" placeholder="dateModified" />
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4 ps-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={JpIsMyCopy} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>
               <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i>Reset</MyButton>
             </div>
             <div className="card-body">
               {JpIsMyCopy}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}

export default Article